import styled, { createGlobalStyle } from "styled-components";

interface PaddingProps {
    paddingTop?: string; 
    paddingLeft?: string; 
    paddingRight?: string; 
    paddingBottom?: string; 
}

export const StyledNav = styled.div`
    .Polaris-Button {
        gap: 9px;
        padding: 4px;
        
        .Polaris-Text--medium {
            font-weight: 400;
            font-size: 13px;
        }
    }

    .Polaris-Button--pressed, .Polaris-Button--pressed:hover, .Polaris-Button--pressed:active, .Polaris-Button--pressed:focus-visible {
        background: rgb(223 223 223);
        .Polaris-Text--medium {
            font-weight: 500;
        }
    }
`

export const StyledClickAble = styled.div`
    cursor: pointer;
`

export const StyledAvatar = styled.div`
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background:rgba(78, 21, 211, 0.5);
    color: #fff;
    font-weight: 500;
    font-size: 12px;
    user-select: none;
`

export const StyledCardHeader = styled.div`
    font-weight: 600;
    background: #EBEBEB;
    padding: 12px;
    width: 100%;
    border-bottom: 1px solid rgba(48, 48, 48, 0.2);
`

export const StyledFlexFullWidth = styled.div`
    flex: 1;
`

export const StyledCard = styled.div`
    margin-top: 12px;
    
    .Polaris-ShadowBevel {
      & > .Polaris-Box {
            padding: 10px 13px;
        }
    }
`

export const StyledPadding = styled.div<PaddingProps>`
    padding-top: ${(props) => props.paddingTop || 'initial'};
    padding-right: ${(props) => props.paddingRight || 'initial'};
    padding-bottom: ${(props) => props.paddingBottom || 'initial'};
    padding-left: ${(props) => props.paddingLeft || 'initial'};
`

export const PolarisModalScopedStyle = createGlobalStyle`
  .modal--email-verified {
    max-width: 30rem !important;
  }
`;